module.exports = __webpack_public_path__ + "img/grzx.5d09a4df.webp";